export default __webpack_public_path__ + "static/media/logo.47f3323c.svg";